import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogOut, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { LoginCard } from "../components/admin/LoginCard";
import { BookingsPanel } from "../components/admin/BookingsPanel";
import { MessagesPanel } from "../components/admin/MessagesPanel";
import { Logo } from "../components/site/Logo";
import { usePageMeta } from "../components/site/SmoothScroll";

export default function Admin() {
  const [user, setUser] = useState(null);
  const [tab, setTab] = useState("bookings");
  usePageMeta("Admin · Bookings Dashboard", "");

  useEffect(() => {
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex, nofollow";
    document.head.appendChild(robots);
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => api.post("/auth/refresh").then(({ data }) => setUser(data)).catch(() => setUser(false)));
    return () => robots.remove();
  }, []);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  if (user === null) {
    return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#D4AF37]" /></div>;
  }
  if (!user) return <LoginCard onLogin={setUser} />;

  return (
    <div data-testid="admin-dashboard" className="min-h-screen" data-lenis-prevent>
      <header className="border-b border-[#D4AF37]/15 bg-[#07040D]/90">
        <div className="mx-auto flex max-w-[1300px] items-center justify-between px-5 py-4 sm:px-8">
          <Link to="/" data-testid="admin-home-link"><Logo testId="admin-logo" /></Link>
          <div className="flex items-center gap-4">
            <span className="hidden text-sm text-slate-400 sm:block">{user.email}</span>
            <button onClick={logout} data-testid="admin-logout-button" className="inline-flex h-9 items-center gap-2 rounded-full border border-[#D4AF37]/30 px-4 text-sm text-slate-200 hover:border-[#D4AF37]">
              <LogOut className="h-4 w-4" /> Log out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-[1300px] px-5 py-10 sm:px-8">
        <h1 className="font-display text-4xl text-white sm:text-5xl">Bookings Dashboard</h1>
        <p className="mt-2 text-slate-400">View, confirm and manage appointment requests and website messages.</p>
        <div className="mt-8 flex gap-6 border-b border-[#D4AF37]/15">
          {["bookings", "messages"].map((t) => (
            <button key={t} onClick={() => setTab(t)} data-testid={`admin-tab-${t}`}
              className={`-mb-px border-b-2 pb-3 text-sm capitalize tracking-wide transition-colors ${tab === t ? "border-[#D4AF37] text-[#F3E5AB]" : "border-transparent text-slate-400 hover:text-slate-200"}`}>
              {t}
            </button>
          ))}
        </div>
        <div className="mt-8">{tab === "bookings" ? <BookingsPanel /> : <MessagesPanel />}</div>
      </main>
    </div>
  );
}
